import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { DownloadPdfButton } from '../../../buttons/DownloadPdfButton';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { DrawApi } from '@apply/api';
import DateBox from 'devextreme-react/date-box';
import { NumericFormat } from 'react-number-format';

export interface IPayeeFormModalParameters {
    draw: DrawApi.IDraw;
    isOpen: boolean;
    closeCallback(): void;
    applicationInsights: ApplicationInsights;
}

export const PayeeFormModal = ({
    draw,
    isOpen,
    closeCallback,
    applicationInsights,
}: IPayeeFormModalParameters): React.ReactElement => {
    const drawApi = new DrawApi.DrawApi(applicationInsights);

    const [dateIssued, set_dateIssued] = useState<Date>(new Date());
    const [bankName, set_bankName] = useState<string>('');
    const [drawFee, set_drawFee] = useState<number | undefined>();

    const [isSubmitted, set_isSubmitted] = useState<boolean>(false);

    if (!isOpen) {
        if (isSubmitted) set_isSubmitted(false);

        return <div></div>;
    }

    if (isSubmitted) {
        return (
            <div>
                <Dialog
                    open={isOpen}
                    aria-labelledby='alert-dialog-title'
                    aria-describedby='alert-dialog-description'
                >
                    <DialogContent>
                        <DialogContentText id='alert-dialog-description'>
                            A PDF will be created and emailed to your address.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <button
                            style={{ padding: 6, marginRight: 20 }}
                            type='button'
                            className='button primary'
                            onClick={() => {
                                closeCallback();
                            }}
                        >
                            Close
                        </button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    return (
        <div>
            <Dialog
                open={isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        Please provide the following information for the Payee Form:
                    </DialogContentText>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div style={{ padding: '0 5px' }}>
                            Date Issued:
                            <DateBox
                                value={dateIssued}
                                onValueChange={(date) => set_dateIssued(date)}
                            />
                        </div>
                        <div style={{ padding: '0 5px' }}>
                            Bank Name:
                            <input
                                type='text'
                                style={{ width: 275 }}
                                value={bankName}
                                onChange={(e) => set_bankName(e.target.value)}
                            />
                        </div>
                        <div style={{ padding: '0 5px' }}>
                            Draw Fee:
                            <NumericFormat
                                style={{ width: 125 }}
                                thousandSeparator=','
                                prefix='$'
                                placeholder='$'
                                value={drawFee}
                                decimalScale={2}
                                allowNegative={false}
                                onValueChange={(values) => set_drawFee(values.floatValue)}
                                required={true}
                                isAllowed={(values) => {
                                    const value = values?.floatValue;
                                    return value === undefined || value === null || value > 0;
                                }}
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <button
                        style={{ padding: 6, marginRight: 20 }}
                        type='button'
                        className='button primary'
                        onClick={() => {
                            drawApi.emailPayeeFormPdf({
                                drawId: draw.id,
                                dateIssued: dateIssued,
                                bankName: bankName,
                                drawFee: drawFee,
                            });
                            set_isSubmitted(true);
                        }}
                    >
                        Print Payee Form
                    </button>
                    <button
                        style={{ padding: 6, marginRight: 20 }}
                        type='button'
                        className='button hollow'
                        onClick={closeCallback}
                    >
                        Close
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
